import React from 'react'
import {Button, Col, Row} from "react-bootstrap";
import DisplayStatus from "./DisplayStatus";
const I18n = require('react-redux-i18n').I18n;

export default class MessagePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pageMsg: '',
            statusType: ''
        };

        MessagePage.isValid = MessagePage.isValid.bind(this);
        this.renderBtn = this.renderBtn.bind(this);
}

    componentDidMount(){
        let param = this.props.location.search;
        let finalParam = param && param.trim() !== '' && param.includes("?type=") && MessagePage.isValid(param.replace("?type=", "")) ? param.replace("?type=", "") : "info";
        this.setState({
            pageMsg:  I18n.t("messagePage." + finalParam),
            statusType: finalParam
        })
    }

   static isValid(param) {
        return param === "error" || param === "cancel" || param === "success" || param === "unknownError";
   }

   renderBtn(type) {
        let label = type === "error" ? "retry" : "close";
        let variant = {
            error: "danger",
            success: "success",
            cancel: "warning",
            info: "info",
            unknownError: "danger"
        }
        return type !== "unknownError" ? <Button variant={variant[type]}
                  title={I18n.t("button." + label)}
                  onClick={() => {
                      type === "error" ? window.history.back() :
                          window.open("about:blank", "_self");
                          window.close()
                  }} > {I18n.t("button." + label)} </Button>:null;
   }

    render() {
        return (
            <Row className="justify-content-md-center">
                <Col lg="4" className="message-page">
                    <DisplayStatus
                        statusMessage={this.state.pageMsg}
                        statusType={this.state.statusType}
                        showAlert={true}
                        dismissible={false}
                    />
                    {this.renderBtn(this.state.statusType)}
                </Col>
            </Row>
        )
    }

}



